import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Socket from '../../services/SocketService';
import ChatWindow from './ChatWindow';
import { sendMessage, hideRoom, showRoom, setActive } from '../../actions/ChatActions';
import '../../styles/chat.scss';

class ChatConductor extends Component {
  constructor(props) {
    super(props);

    this.myStatus = this.myStatus.bind(this);
    this.handleResize = this.handleResize.bind(this);

    this.state = {
      windowWidth: window.innerWidth,
    };
  }

  componentDidMount() {
    Socket.chat.on('incoming.message', this.consumeMessage.bind(this));
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    Socket.chat.off('incoming.message');
    window.removeEventListener('resize', this.handleResize);
  }

  consumeMessage(payload) {
    const { notifications } = this.props;
    const status = this.myStatus();

    if (status === 'Busy' || status === 'Offline') {
      return;
    }

    if (notifications && !document.hasFocus() && window.Notification) {
      const from = `${payload.firstName} ${payload.lastName}`;
      const result = new Notification(`Message from ${from}`, { body: payload.message }); // eslint-disable-line
    }

    this.props.showRoom(payload);
  }

  calculateLocation(index) {
    const { rooms } = this.props;
    const chatWindowWidth = 272;
    const maxSpace = ((chatWindowWidth * rooms.length) + (rooms.length * 10));

    if (maxSpace > this.state.windowWidth) {
      let bestView = Math.round(this.state.windowWidth / rooms.length) - (chatWindowWidth / rooms.length);

      if (bestView < 40) {
        bestView = 40;
      }

      if (index === 0) {
        return `${(index * bestView) + 10}px`;
      }

      return `${(index * bestView)}px`;
    }

    return  `${(index * chatWindowWidth) + 10}px`;
  }

  handleResize() {
    this.setState({ windowWidth: window.innerWidth });
  }

  myStatus() {
    const { users, user } = this.props;

    let myStatus = 'Offline';

    if (users.length) {
      myStatus = (_.find(users, (o) => { return o.id === user.id; }) || {}).status || 'Available';
    }

    return myStatus;
  }

  render() {
    const { activeRoom, rooms, user, users } = this.props;
    const windows = [];

    rooms.forEach((room, index) => {
      const { status, avatar } = _.find(users, (o) => { return o.id === room.id; });
      const style = {
        right: this.calculateLocation(index),
      };

      windows.push(
        <ChatWindow
          me={user.id}
          room={room.id}
          status={status}
          key={room.id}
          title={`${room.firstName} ${room.lastName}`}
          close={() => { this.props.hideRoom(room.id); }}
          send={this.props.sendMessage}
          setActive={this.props.setActive}
          style={style}
          active={activeRoom === room.id}
          avatar={avatar}
        />,
      );
    });

    return (
      <div id="chat-conductor">
        {windows}
      </div>
    );
  }
}

ChatConductor.defaultProps = {
  notifications: false,
  rooms: [],
};

ChatConductor.propTypes = {
  activeRoom: PropTypes.number,
  hideRoom: PropTypes.func,
  notifications: PropTypes.bool,
  rooms: PropTypes.array,
  sendMessage: PropTypes.func,
  setActive: PropTypes.func,
  showRoom: PropTypes.func,
  user: PropTypes.object,
  users: PropTypes.array,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ sendMessage, hideRoom, showRoom, setActive }, dispatch);
}

function mapStateToProps(state) {
  return {
    notifications: _.get(state, 'app.user.data.notifications'),
    rooms: state.chat.rooms,
    user: state.app.user,
    users: state.chat.users,
    activeRoom: state.chat.activeRoom,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatConductor);
